export const FETCH_DAILY_TABLE_LISTING_FAILURE = 'FETCH_DAILY_TABLE_LISTING_FAILURE';
export const FETCH_DAILY_TABLE_LISTING_SUCCESS = 'FETCH_DAILY_TABLE_LISTING_SUCCESS';